import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

function MarketplaceRedirect() {
  const nav = useNavigate();
  useEffect(() => {
    nav({ to: "/dashboard" });
  }, [nav]);
  return null;
}

export const Route = createFileRoute("/_app/marketplace")({
  component: MarketplaceRedirect,
});
